// Open navbarSide when button is clicked
var mouse_is_inside = false;
$('#js-nav-trigger').on('click', function (e) {
  e.preventDefault();

  $('.nav').toggleClass('open');
  $('html').toggleClass('no-scroll');
  $('body').toggleClass('no-scroll');
});

$('#js-sidebar-trigger').on('click', function (e) {
  e.preventDefault();

  $('.sidebar__nav').slideToggle();
});

$('#js-video-modal').on('click', function (e) {
  e.preventDefault();

  $('.video__overlay').fadeIn();
  $('html').addClass('no-scroll');
  $('body').addClass('no-scroll');

  e.stopPropagation();
});

var stopVideo = function (element) {
  // var iframe = document.querySelector('iframe');
  // var player = new Vimeo.Player(iframe);

  // player.pause();

  var video = document.querySelector('video.fp-engine');
  video.pause();
};

$('#js-modal-close').on('click', function (e) {
  e.preventDefault();

  $('.video__overlay').fadeOut();
  stopVideo();
  $('html').removeClass('no-scroll');
  $('body').removeClass('no-scroll');
});
/*
$(window).click(function () {
  if ($('.video__overlay').is(':visible')) {
    $('.video__overlay').fadeOut();
    stopVideo();
    $('html').removeClass('no-scroll');
    $('body').removeClass('no-scroll');
  }
});
*/
$(document).ready(function () {
  $('.video__container').hover(
    function () {
      mouse_is_inside = true;
    },
    function () {
      mouse_is_inside = false;
    },
  );

  $('body').mouseup(function () {
    if (!mouse_is_inside) {
      $('.video__overlay').fadeOut();
      stopVideo();
      $('html').removeClass('no-scroll');
      $('body').removeClass('no-scroll');
    }
  });
});

$(document).keydown(function (event) {
  if (event.keyCode == 27) {
    $('.video__overlay').fadeOut();
    stopVideo();
    $('html').removeClass('no-scroll');
    $('body').removeClass('no-scroll');
  }
});

$(window).scroll(function () {
  if ($(this).scrollTop() > 150) {
    $('.header__content').addClass('sticky');
  } else {
    $('.header__content').removeClass('sticky');
  }
});

$('.sub__title--collapse').on('click', function (e) {
  $(this).siblings('.page__copy--collapsable, .page__links--collapsable').slideToggle();
});



// WEBPACK FOOTER //
// ./js/navigation.js